import React from 'react';
import PeopleListItem from './PeopleListItem'
const PeopleList = ({ group,saveGroup,deletePerson}) => {


 

const peopleList = group.people!= undefined ? group.people.map( (i,index) => {
 
    return <PeopleListItem index={index} key={index} saveGroup={saveGroup} group={group} deletePerson={deletePerson}/>
  }): null;

  return peopleList;


}

export default PeopleList